import { render } from "./Group-5.vue?vue&type=template&id=6770e198"
import script from "./Group-5.vue?vue&type=script&lang=js"
export * from "./Group-5.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__